module.exports = __webpack_public_path__ + "img/1F1FA-1F1EC.4cbb1c86.svg";